import { Helmet } from 'react-helmet-async';

import { usePersonSchema } from './hooks/usePersonSchema';

export function PersonSchema() {
	const {
		data: { schemaJson },
	} = usePersonSchema();

	return (
		<Helmet>
			<script type="application/ld+json">{schemaJson}</script>
		</Helmet>
	);
}
